import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64cd64b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Actions")
], -1))
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountDetails = _resolveComponent("AccountDetails")!
  const _component_CancellationSection = _resolveComponent("CancellationSection")!
  const _component_BillingSection = _resolveComponent("BillingSection")!
  const _component_AutofillSection = _resolveComponent("AutofillSection")!
  const _component_ReinstatementSection = _resolveComponent("ReinstatementSection")!

  return (_ctx.accountId && _ctx.accountId !== '')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading..."))
          : _createCommentVNode("", true),
        (_ctx.hasError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Failed to load account data"))
          : _createCommentVNode("", true),
        (_ctx.hasTransactionError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Certain account data (cancellation info) could not be found"))
          : _createCommentVNode("", true),
        (!_ctx.isLoading && !_ctx.hasError)
          ? (_openBlock(), _createBlock(_component_AccountDetails, {
              key: 3,
              onNavigatedAccountSection: _ctx.navigateToRoot,
              currentUser: _ctx.currentUser,
              accountInfo: _ctx.accountInfo,
              transactionData: _ctx.transactionData
            }, null, 8, ["onNavigatedAccountSection", "currentUser", "accountInfo", "transactionData"]))
          : _createCommentVNode("", true),
        _hoisted_5,
        _hoisted_6,
        (_ctx.inquiryType === '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  class: "action-link",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.selectAction('Cancellation')), ["prevent"])),
                  href: ""
                }, "Cancellation >>")
              ]),
              (_ctx.hasReinstatementPermission)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("a", {
                      class: "action-link",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectAction('Reinstatement')), ["prevent"])),
                      href: ""
                    }, "Reinstatement >>")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  class: "action-link",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.selectAction('Billing')), ["prevent"])),
                  href: ""
                }, "Billing >>")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  class: "action-link",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.selectAction('Autofill Ticket Fields')), ["prevent"])),
                  href: ""
                }, " Autofill Ticket Fields >> ")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.inquiryType !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("a", {
                class: "action-link",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.selectAction('')), ["prevent"])),
                href: ""
              }, "<< Go Back ")
            ]))
          : _createCommentVNode("", true),
        (_ctx.inquiryType === 'Cancellation')
          ? (_openBlock(), _createBlock(_component_CancellationSection, {
              key: 6,
              accountInfo: _ctx.accountInfo,
              currentUser: _ctx.currentUser,
              userOktaInfo: _ctx.userOktaInfo,
              onAccountCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.reloadOnCancel())),
              transactionData: _ctx.transactionData
            }, null, 8, ["accountInfo", "currentUser", "userOktaInfo", "transactionData"]))
          : _createCommentVNode("", true),
        (_ctx.inquiryType === 'Billing')
          ? (_openBlock(), _createBlock(_component_BillingSection, {
              key: 7,
              accountInfo: _ctx.accountInfo
            }, null, 8, ["accountInfo"]))
          : _createCommentVNode("", true),
        (_ctx.inquiryType === 'Autofill Ticket Fields')
          ? (_openBlock(), _createBlock(_component_AutofillSection, {
              key: 8,
              accountInfo: _ctx.accountInfo,
              currentUser: _ctx.currentUser
            }, null, 8, ["accountInfo", "currentUser"]))
          : _createCommentVNode("", true),
        (_ctx.inquiryType === 'Reinstatement' &&
      _ctx.hasReinstatementPermission)
          ? (_openBlock(), _createBlock(_component_ReinstatementSection, {
              key: 9,
              accountInfo: _ctx.accountInfo,
              userOktaInfo: _ctx.userOktaInfo,
              currentUser: _ctx.currentUser
            }, null, 8, ["accountInfo", "userOktaInfo", "currentUser"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}